var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/thumb-navigation-link.tsx";
import classNames from 'clsx';
import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import IconWithCounter from 'soapbox/components/icon-with-counter';
import { Icon, Text } from 'soapbox/components/ui';

const ThumbNavigationLink = _ref => {
  let {
    count,
    src,
    text,
    to,
    exact,
    paths
  } = _ref;
  const {
    pathname
  } = useLocation();

  const isActive = () => {
    if (paths) {
      return paths.some(path => pathname.startsWith(path));
    } else {
      return exact ? pathname === to : pathname.startsWith(to);
    }
  };

  const active = isActive();
  return /*#__PURE__*/React.createElement(NavLink, {
    to: to,
    exact: exact,
    className: "thumb-navigation__link",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 31,
      columnNumber: 5
    }
  }, count !== undefined ? /*#__PURE__*/React.createElement(IconWithCounter, {
    src: src,
    className: classNames({
      'h-5 w-5': true,
      'text-gray-600': !active,
      'text-primary-500': active
    }),
    count: count,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 33,
      columnNumber: 9
    }
  }) : /*#__PURE__*/React.createElement(Icon, {
    src: src,
    className: classNames({
      'h-5 w-5': true,
      'text-gray-600': !active,
      'text-primary-500': active
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 43,
      columnNumber: 9
    }
  }), /*#__PURE__*/React.createElement(Text, {
    tag: "span",
    size: "xs",
    weight: "medium",
    className: classNames({
      'text-gray-600': !active,
      'text-primary-500': active
    }),
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 7
    }
  }, text));
};

export default ThumbNavigationLink;